import { FunctionComponent } from 'react';
import { Card, CardProps, Layout } from '@shopify/polaris';
import { StyledElement } from '@ui/types';
import { Container } from '../common';

export interface SectionedContainerProps extends StyledElement {
  secondary: React.ReactNode;
}

export type SectionedProps = FunctionComponent<SectionedContainerProps> & {
  Card: typeof CardContainer;
};

// eslint-disable-next-line react/prop-types
const Sectioned: SectionedProps = ({ children, className, secondary }) => (
  <Container className={className}>
    <Layout>
      <Layout.Section>{children}</Layout.Section>
      <Layout.Section secondary>{secondary}</Layout.Section>
    </Layout>
  </Container>
);

export interface CardSectionedContainerProps extends SectionedContainerProps {
  secondaryCard: CardProps;
  childrenCard: CardProps;
}

const CardContainer: FunctionComponent<CardSectionedContainerProps> = ({
  children,
  childrenCard,
  className,
  secondary,
  secondaryCard,
}) => {
  const secondaryElement = <Card {...secondaryCard}>{secondary}</Card>;

  return (
    <Sectioned className={className} secondary={secondaryElement}>
      <Card {...childrenCard}>{children}</Card>
    </Sectioned>
  );
};

Sectioned.Card = CardContainer;

export default Sectioned;
